import { render, staticRenderFns } from "./ChangeLogAddressCard.vue?vue&type=template&id=34a544b9&scoped=true"
import script from "./ChangeLogAddressCard.vue?vue&type=script&lang=js"
export * from "./ChangeLogAddressCard.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogAddressCard.vue?vue&type=style&index=0&id=34a544b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a544b9",
  null
  
)

export default component.exports